import { EuiComboBox, EuiComboBoxOptionOption, EuiFlexGroup, EuiFormLabel } from '@elastic/eui';
import { useIntl } from 'react-intl';
import { isVATDeductible } from 'cache';
import { useLocalCache } from 'hooks/useLocalCache';

import * as S from './FiltersSidebar.styles';

export const VATDeductibleFilter = (): JSX.Element => {
  const { formatMessage } = useIntl();
  const localFilters = useLocalCache();
  const getCurrentOption = (selected?: boolean | null): { label: string; value?: boolean } => {
    if (typeof selected === 'undefined') return { label: 'Tutte' };
    if (selected === true) return { label: 'Con IVA deducibile', value: selected };
    if (selected === false) return { label: 'Senza IVA deducibile', value: selected };
    return { label: 'Tutti' };
  };

  return (
    <S.SidebarFilterWrapper>
      <EuiFlexGroup direction="column">
        <EuiFormLabel style={{ marginRight: '10px' }}>
          {formatMessage({ id: 'filters.isVATDeductible.label' })}
        </EuiFormLabel>
        <EuiComboBox
          aria-label="Accessible screen reader label"
          placeholder="Select a single option"
          isClearable={false}
          singleSelection={{ asPlainText: true }}
          options={[
            { label: 'Con IVA deducibile', value: true },
            { label: 'Senza IVA deducibile', value: false },
            { label: 'Tutti', value: undefined },
          ]}
          selectedOptions={[
            getCurrentOption(localFilters?.data?.isVATDeductible) as EuiComboBoxOptionOption<boolean | null>,
          ]}
          onChange={(x): void => {
            isVATDeductible(x[0]?.value);
          }}
        />
      </EuiFlexGroup>
    </S.SidebarFilterWrapper>
  );
};
